/**
 * Created by n.gorte on 16.08.2017.
 */
'use strict';

import { equalArray } from 'plugin/liferay-widgets-react-web';
import L from 'external/leaflet';

export default class SelectionDisplayPlugin {

    constructor(props) {
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
    }

    initOptions(o) {
        return this.options(o);
    }

    init(map, o, reEvaluate) {
        this.map = map;
    }

    compareSelectedLayers(a, b) {
        return a.feature.properties.id === b.feature.properties.id;
    }

    options(o) {
        if ((o && o.selectedLayers && !equalArray(o.selectedLayers, this.selectedLayers, this.compareSelectedLayers)) || (o.selectedLayers && !this.boundRequestHandled)) {
            console.log('SelectionDisplayPlugin options()', o);
            this.boundRequestHandled = false;
            const currentBounds = this.map.getBounds();
            const l = new L.featureGroup(o.selectedLayers);
            if (!currentBounds.contains(l.getBounds())) {
                o.boundRequest = {
                    bounds: l.getBounds(),
                    options: { animate: false, padding: [ 50, 50 ] },
                    cb: this.boundRequestCb
                };
            } else {
                this.boundRequestCb();
            }
        }
        return o;
    }

    update(map, o) {
        if (o && o.selectedLayers && !equalArray(o.selectedLayers, this.selectedLayers, this.compareSelectedLayers)) {
            this.selectedLayers = o.selectedLayers;
        }
    }

    remove() {
        this.map = null;
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }

}

SelectionDisplayPlugin.staticPlugin = true;




// WEBPACK FOOTER //
// ./js/plugins/SelectionDisplayPlugin.js